import * as React from 'react';
import { IconProps } from '../types';

const IcInfor = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M12.5 2.692a9.308 9.308 0 1 0 0 18.616 9.308 9.308 0 0 0 0-18.616ZM1.5 12c0-6.075 4.925-11 11-11s11 4.925 11 11-4.925 11-11 11-11-4.925-11-11Z"
      clipRule="evenodd"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M12.51 10.57c.824 0 1.654.566 1.654 1.265v5.9c0 .699-.85 1.265-1.674 1.265s-1.667-.566-1.667-1.264v-5.901c0-.699.863-1.265 1.687-1.265ZM12.49 6c-1.099 0-1.667.755-1.667 1.686 0 .931.568 1.686 1.667 1.686h.02c1.1 0 1.654-.755 1.654-1.686C14.164 6.755 13.61 6 12.51 6h-.02Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcInfor;
